import * as THREE from 'three';

const tapCursorComponent = {
  init: function () {
    this.elementsEntity = document.getElementById('entity_elements');
    this.raycaster = new THREE.Raycaster();
    this.camera = document.getElementById('camera');
    this.threeCamera = this.camera.getObject3D('camera');
    this.cursor = document.getElementById('cursor');
    this.ground = document.getElementById('ground');

    this.rayOrigin = new THREE.Vector2(0, 0);
    this.cursorLocation = new THREE.Vector3(0, 0, 0);
    let hasPlacedModel = false;
    this.el.sceneEl.addEventListener('click', () => {
      if (!hasPlacedModel) {
        hasPlacedModel = true;
        this.elementsEntity.setAttribute('position', this.el.object3D.position);
        this.elementsEntity.setAttribute('visible', 'true');
        this.elementsEntity.play();
        this.cursor.parentNode.removeChild(this.cursor);

        // Disable camera look-controls to prevent dragging
        this.camera.setAttribute('look-controls', 'touchEnabled: false');

        // this.camera.setAttribute('raycaster', 'objects: .cantap');
        const scene = window.AFRAME.scenes[0];
        const mouseCursor = document.createElement('a-entity');
        mouseCursor.setAttribute('cursor', 'rayOrigin: mouse');
        mouseCursor.setAttribute(
          'raycaster',
          'objects: .clickable, .cursor-clickable'
        );
        scene.appendChild(mouseCursor);
        this.videoAutoPlay();
      }
    });
  },
  videoAutoPlay() {
    const videos = document.querySelectorAll('video');
    for (let video of videos) {
      const videoEntityId = video.getAttribute('video_entity_id');
      const autoplay = video.getAttribute('video_autoplay');
      if (autoplay == 'true' && videoEntityId) {
        const videoEntity = document.getElementById(videoEntityId);
        if (videoEntity) {
          video.play();
        }
      }
    }
  },
  tick: function () {
    this.raycaster.setFromCamera(this.rayOrigin, this.threeCamera);
    const intersects = this.raycaster.intersectObject(
      this.ground.object3D,
      true
    );
    if (intersects.length > 0) {
      const [intersect] = intersects;
      this.cursorLocation = intersect.point;
    }
    this.el.object3D.position.y = 0.1;
    this.el.object3D.position.lerp(this.cursorLocation, 0.4);
    this.el.object3D.rotation.y = this.threeCamera.rotation.y;
  },
};

export { tapCursorComponent };
